import type { ServiceProvided } from "../../treatments/treatment-prescription/types";
import { activeServicesProvidedFilter } from "../../treatments/treatment-prescription/utils";

// Períodos de services_provided por tratamento. A coleção NÃO tem campo de estado: "A Decorrer" é
// calculado das duas datas contra hoje, e a única definição na app é activeServicesProvidedFilter —
// o mesmo predicado que pinta o chip "A Decorrer" na tabela "Serviços Prestados" da ficha do
// tratamento. Reutilizado (nunca reescrito) para o dashboard não divergir da ficha.

export type ServiceProvidedSpan = {
    service: number | null;
    session_periodicity: string | null;
    date_begin: string | null;
    date_end: string | null;
};

export type SpansByTreatment = Record<number, Array<ServiceProvidedSpan>>;

// O span do dashboard traz só as duas datas que o predicado lê; o cast evita reconstruir um
// ServiceProvided completo (id, prescrição, auditoria) que nada aqui usa.
const isOngoingSpan = (span: ServiceProvidedSpan) => {
    const isOngoing = activeServicesProvidedFilter(span as unknown as ServiceProvided);
    return isOngoing;
};

// Um tratamento pode ter várias prescrições e portanto vários períodos do mesmo serviço: basta um
// estar a decorrer para a disciplina estar a decorrer.
export const hasOngoingSpanOfService = (spans: Array<ServiceProvidedSpan> | undefined, service: number) => {
    const hasOngoing = (spans || []).some((span) => Number(span.service) === service && isOngoingSpan(span));
    return hasOngoing;
};
